import { Button, Typography } from 'antd';
import { MutableRefObject, useContext, useRef } from 'react';
import { SetSliderValuesContext } from '../../config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMap, faPen, faThumbsUp } from '@fortawesome/free-solid-svg-icons';

const { Title, Text } = Typography;

export const WelcomeJourney = ({
  processWelcomeJourney,
  welcomeJourneyStep,
  container,
}: {
  processWelcomeJourney: () => void;
  welcomeJourneyStep: number;
  container: MutableRefObject<HTMLDivElement>;
}) => {
  const setSliderValues = useContext(SetSliderValuesContext);

  const onStart = (args: 'scratch' | 'normal') => {
    if (welcomeJourneyStep === 2) {
      processWelcomeJourney();
      container.current?.scrollTo(0, 0);
      if (args === 'scratch') setSliderValues([0, 0, 0, 0, 0, 0, 0, 99, 0, 0]);
    }
  };

  return (
    <div ref={container} style={{ height: 650, padding: 10 }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
        }}
      >
        <Title level={2}>Build Your Own Energy Grid!</Title>

        <Text>
          Think you can balance energy costs, emissions, and security in
          Australia?
        </Text>

        <Button
          onClick={() => {
            processWelcomeJourney();
            container.current.scroll({ behavior: 'smooth', top: 100 });
          }}
          style={{
            transition: 'all 1s ease 0s',
            opacity: welcomeJourneyStep > 1 ? '0' : '100',
            maxWidth: 300,
          }}
          disabled={welcomeJourneyStep > 1}
          type="primary"
          icon={<FontAwesomeIcon icon={faThumbsUp} />}
          size="large"
        >
          I accept this challenge
        </Button>
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          transition: 'all 1s ease 0s',
          opacity: welcomeJourneyStep < 2 ? '0' : '100',
        }}
      >
        <Title level={2}>Congratulations, You're in Charge!</Title>

        <Text>
          You now manage 10 power plants: Nuclear, Wind, Solar, Hydro, Fossil
          Carbon Capture and Storage, Coal, Gas, Blackout, Battery, and Pump
          Storage.
        </Text>

        <Text>Ready to begin?</Text>

        <Button
          onClick={() => onStart('scratch')}
          style={{ marginBottom: 10, maxWidth: 300 }}
          type="primary"
          icon={<FontAwesomeIcon icon={faPen} />}
          size="large"
        >
          Build from scratch
        </Button>
        <Button
          onClick={() => onStart('normal')}
          style={{ maxWidth: 300, marginBottom: 20 }}
          type="primary"
          icon={<FontAwesomeIcon icon={faMap} />}
          size="large"
        >
          Build from today's energy grid
        </Button>
      </div>
    </div>
  );
};
